import React, { useEffect, useState } from 'react'
import TabNavigation from './tabNavigation'
import DataTableSection from './datatable'
import { useLocation, useParams } from 'react-router-dom';
import { searchProperties } from '../../services/propertyService';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux';
import useUserLocation from '../../hooks/useUserLocation';

const SearchResultPage = () => {
  const location = useLocation();
  const { query } = useParams(); // Extract the dynamic query from the URL

  // 🔹 **Single State for Category & Parent Category**
  const [categoryState, setCategoryState] = useState({
    category: '',
    parentCategory: ''
  });

  const [searchData, setSearchData] = useState(null);
  const [locationDetailsState, setLocationDetailsState] = useState({ city: '', state: '', country: '' });

  const [searchResults, setSearchResults] = useState({ totalResults: "", properties: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [selectedSort, setSelectedSort] = useState("Relevance"); // State for sorting

  const [category, setCategory] = useState(""); // **Mapped category state**



  console.log("Selected Sort:", selectedSort);

  console.log("searchData", searchData);
  console.log("searchResults", searchResults);

  // 🔹 **Category Mapping**
  const categoryMapping = {
    "Residential": "Residential",
    "Commercial": "Commercial",
    "Unfurnished-property": "unfurnished",
    "Furnished-Property": "furnished",
    "Ready-to-Move": "ready_to_move",
    "Plot": "plot",
    "Buy": "sell",
    "Rent": "rent",
  };



  // Function to check if the string is Base64 encoded
  const isBase64 = (str) => {
    try {
      return btoa(atob(str)) === str; // Check if the string is valid Base64
    } catch (err) {
      return false; // Return false if atob throws an error (i.e., not valid Base64)
    }
  };

  useEffect(() => {
    // Step 1: Check if the query is Base64-encoded before attempting to decode
    let decompressedData = null;

    if (isBase64(query)) {
      // If it's Base64-encoded, use atob() to decode
      decompressedData = atob(query);
    }
    console.log("decompressedData", decompressedData, isBase64(query))
    // Step 2: Parse the JSON data (if it's not Base64-encoded, it's assumed to be the raw string)
    if (decompressedData) {
      try {
        const parsedData = JSON.parse(decompressedData);

        setSearchData(parsedData);
      } catch (error) {
        console.error("Error parsing decompressed data:", error);
        setSearchData(null);
      }
    } else {
      console.error("Failed to process data.");
    }
  }, [query]);


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const locationData = queryParams.get('location'); // Get the 'location' query parameter
    const categoryParam = queryParams.get("category");
    const parentCategoryParam = queryParams.get("parentCategory"); // Get parent category from URL
    console.log("locationData:", locationData);
    console.log("Category:", categoryParam);
    console.log("Parent Category:", parentCategoryParam);

    setCategoryState({
      category: categoryMapping[categoryParam] || categoryParam || '',
      parentCategory: parentCategoryParam || ''
    });

    if (locationData) {
      const decodedLocation = JSON.parse(decodeURIComponent(locationData)); // Decode and parse the location data
      setLocationDetailsState(decodedLocation); // Set location data in state
    }
  }, []);





  console.log("searchData", searchData)



  // 🔹 **Filter out empty values & empty arrays**
  const filteredParams = {};


  // Define mapping for specific queries to their labels
  const queryMapping = {
    Residential: "Residential ",
    commercial: "Commercial ",
    unfurnished: "Unfurnished ",
    furnished: "Furnished ",
    ready_to_move: "Ready to Move ",
    // Add more mappings as necessary
  };
  // Function to capitalize the first letter of each word in the string
  const capitalizeFirstLetter = (str) => {
    return str
      .split('-') // Split the string by hyphens
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter and make the rest lowercase
      .join(' '); // Join the words back with a space
  };


  console.log("searchResults", searchResults)

  // Call useUserLocation hook directly inside the component
  const { location: userLocation, fetchLocation } = useUserLocation();
  useEffect(() => {
    fetchLocation(); // Call this inside useEffect or use it directly in the return statement
  }, []);



  const FormateText = () => {
    // Helper function to get the location details from URL
    const getLocationFromSearchData = () => {
      if (searchData?.location) {
        return searchData?.location;
      }
      if (searchData?.userSelectedLocationDetails?.city) {
        return searchData?.userSelectedLocationDetails?.city;
      }
      return null;
    };

    const checkLocationFromSearchParams = () => {
      // Handle case when query is Base64
      if (isBase64(query)) {
        const location = getLocationFromSearchData();
        if (location) {
          return `Properties in ${location}`;
        }
      }

      // Handle case when query is a normal string
      if (locationDetailsState.city) {
        return `Properties in ${locationDetailsState?.city}`;
      }

      // Fallback: Use current user's location if available
      if (userLocation?.city) {
        return ` Properties in ${userLocation?.city}`;
      }

      // Default: Fallback to New Delhi if no city found
      return `Properties in New Delhi`;
    };

    // Call the function and return the formatted text
    return checkLocationFromSearchParams();
  };




  const fetchSearchResults = async () => {
    console.log("fetchSearchResultsCall")
    setLoading(true);
    setError(null);

    const formData = new FormData();

    // Helper function to append only non-empty values
    const appendIfExists = (key, value) => {
      if (value && (Array.isArray(value) ? value.length > 0 : true)) {
        formData.append(key, Array.isArray(value) ? JSON.stringify(value) : value);
      }
    };

    // Handle activeTab logic
    let finalActiveTab = searchData?.activeTab || categoryState.parentCategory || "Sell"; // Default to Sell
    let finalSubPropertyType = searchData?.subPropertyType || "";
    let finalCategory = categoryState.category; // Default category from state
    if (searchData?.activeTab === "Buy") {
      finalActiveTab = "Sell";
    } else if (searchData?.activeTab === "Plot") {
      finalActiveTab = "Sell";
      finalSubPropertyType = "Plot"; // Move "Plot" to subPropertyType
    }
    else if (searchData?.activeTab === "Commercial") {
      finalActiveTab = "Sell";
      finalCategory = "Commercial"; // Set category to Commercial
    }
    // 🔹 If category is PG, set activeTab as PG and do NOT pass category
    if (categoryState.category === "PG") {
      finalActiveTab = "PG"; // Set PG in activeTab
      finalCategory = null; // Do not send category
    }

    // Append data to FormData
    // appendIfExists("budgetMin", searchData?.budgetMin);
    appendIfExists("budgetMax", searchData?.budgetMax);
    appendIfExists("propertyType", searchData?.propertyType);
    appendIfExists("bhkSelection", searchData?.bhkSelection);
    appendIfExists("commercialSelection", searchData?.commercialSelection);
    appendIfExists("pgGender", searchData?.pgGender);
    appendIfExists("subSelection", searchData?.subSelection);
    appendIfExists("activeTab", finalActiveTab); // Updated activeTab
    appendIfExists("page", searchData?.page);
    appendIfExists("limit", searchData?.limit);
    appendIfExists("subPropertyType", finalSubPropertyType); // Updated subPropertyType
    appendIfExists("location", searchData?.location);

    appendIfExists("sortOption", selectedSort); // **Pass selected sort option**



    // 🔹 Pass category **only if it's NOT PG**
    if (finalCategory && finalCategory !== "PG") {
      appendIfExists("category", finalCategory);
    }


    try {
      const results = await searchProperties(formData);
      console.log("API Response:", results);
      if (results?.success) {
        setSearchResults(results);
      }
    } catch (err) {
      setError("Failed to fetch search results");
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    if (searchData || categoryState.category || categoryState.parentCategory) {
      fetchSearchResults();
    }
  }, [JSON.stringify(searchData), selectedSort, categoryState]);







  return (
    <div className='py-[150px] bg-[#f5f5f5]'>
      <div className='w-[78%] ml-5'>
        <TabNavigation totalResults={searchResults?.totalResults} setSelectedSort={setSelectedSort} />
        <div className='py-4'>
          <p className='text-[26px] font-normal'>
            {/* 7933 results | 2 BHK Flats in Jaipur for Sale */}
            {query ? `${searchResults?.totalResults || 0} results | ${FormateText()}` : 'Search Results'}
          </p>
        </div>
        <DataTableSection searchResults={searchResults?.properties} />
      </div>
      <div className='w-[5%]'></div>
      <div className='w-[25%]'></div>
    </div>
  )
}

export default SearchResultPage